export default __webpack_public_path__ + "static/media/kid.55b24820.png";